import { autoVeloSiteCallForAMethod } from '@wix/bi-logger-auto-velo/v2';
import { createContent as universalCreateContent, getContent as universalGetContent, updateContent as universalUpdateContent, updateContentByKey as universalUpdateContentByKey, deleteContent as universalDeleteContent, queryContents as universalQueryContents, queryContentsLegacy as universalQueryContentsLegacy, searchContents as universalSearchContents, bulkCreateContent as universalBulkCreateContent, bulkUpdateContent as universalBulkUpdateContent, bulkUpdateContentByKey as universalBulkUpdateContentByKey, bulkDeleteContent as universalBulkDeleteContent, removeContentsByFilter as universalRemoveContentsByFilter, republishContentByFilter as universalRepublishContentByFilter, } from './multilingual-translation-v1-content.universal';
import { NodeType, WidthType, PluginContainerDataAlignment, Type, Target, TextAlignment, LineStyle, Width, Alignment, ViewMode, LayoutType, Orientation, Crop, ThumbnailsAlignment, Source, MapType, ViewRole, VoteRole, PollLayoutType, PollLayoutDirection, BackgroundType, DecorationType, FontType, AppType, InitialExpandedItems, Direction, VerticalAlignment, NullValue, UpdaterIdentity, PublishStatus, SortOrder, SortType, SortDirection, MissingValues, ScalarType, NestedAggregationType, Interval, AggregationType, Mode, State, SiteCreatedContext, Namespace, DeleteStatus, WebhookIdentityType, } from './multilingual-translation-v1-content.universal';
function wrapSideEffect(sideEffect) {
    return (...args) => {
        try {
            sideEffect(...args);
        }
        catch (e) {
            // add some kind of log?
        }
    };
}
function createSideEffects(sideEffects) {
    return Object.entries(sideEffects).reduce((acc, [key, value]) => {
        acc[key] = wrapSideEffect(value);
        return acc;
    }, {});
}
function createVeloSiteCallLogData(params) {
    return autoVeloSiteCallForAMethod(Object.assign({ environment: 'front-end', entity_name: 'wix.multilingual.translation.v1.content', module_name: 'wix-multilingual.v2' }, params));
}
export function sdkFactory({ appEssentials }) {
    const httpClient = appEssentials.httpClient;
    const logger = appEssentials
        .biLoggerFactory({ endpoint: 'auto-velo' })
        .logger();
    return {
        createContent: (content) => {
            const methodLogData = {
                method_name: 'createContent',
                service_name: 'wix.multilingual.translation.content.v1.TranslationContent',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-multilingual.v2,entity=wix.multilingual.translation.v1.content,environment=velo-frontend,method-fqn=wix.multilingual.translation.content.v1.TranslationContent.createContent',
            };
            return universalCreateContent(content, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getContent: (contentId) => {
            const methodLogData = {
                method_name: 'getContent',
                service_name: 'wix.multilingual.translation.content.v1.TranslationContent',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-multilingual.v2,entity=wix.multilingual.translation.v1.content,environment=velo-frontend,method-fqn=wix.multilingual.translation.content.v1.TranslationContent.getContent',
            };
            return universalGetContent(contentId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateContent: (_id, content, options) => {
            const methodLogData = {
                method_name: 'updateContent',
                service_name: 'wix.multilingual.translation.content.v1.TranslationContent',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-multilingual.v2,entity=wix.multilingual.translation.v1.content,environment=velo-frontend,method-fqn=wix.multilingual.translation.content.v1.TranslationContent.updateContent',
            };
            return universalUpdateContent(_id, content, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateContentByKey: (content, options) => {
            const methodLogData = {
                method_name: 'updateContentByKey',
                service_name: 'wix.multilingual.translation.content.v1.TranslationContent',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-multilingual.v2,entity=wix.multilingual.translation.v1.content,environment=velo-frontend,method-fqn=wix.multilingual.translation.content.v1.TranslationContent.updateContentByKey',
            };
            return universalUpdateContentByKey(content, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        deleteContent: (contentId) => {
            const methodLogData = {
                method_name: 'deleteContent',
                service_name: 'wix.multilingual.translation.content.v1.TranslationContent',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-multilingual.v2,entity=wix.multilingual.translation.v1.content,environment=velo-frontend,method-fqn=wix.multilingual.translation.content.v1.TranslationContent.deleteContent',
            };
            return universalDeleteContent(contentId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        queryContents: (options) => {
            const methodLogData = {
                method_name: 'queryContents',
                service_name: 'wix.multilingual.translation.content.v1.TranslationContent',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-multilingual.v2,entity=wix.multilingual.translation.v1.content,environment=velo-frontend,method-fqn=wix.multilingual.translation.content.v1.TranslationContent.queryContents',
            };
            return universalQueryContents(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        queryContentsLegacy: (options) => {
            const methodLogData = {
                method_name: 'queryContentsLegacy',
                service_name: 'wix.multilingual.translation.content.v1.TranslationContent',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-multilingual.v2,entity=wix.multilingual.translation.v1.content,environment=velo-frontend,method-fqn=wix.multilingual.translation.content.v1.TranslationContent.queryContentsLegacy',
            };
            return universalQueryContentsLegacy(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        searchContents: (options) => {
            const methodLogData = {
                method_name: 'searchContents',
                service_name: 'wix.multilingual.translation.content.v1.TranslationContent',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-multilingual.v2,entity=wix.multilingual.translation.v1.content,environment=velo-frontend,method-fqn=wix.multilingual.translation.content.v1.TranslationContent.searchContents',
            };
            return universalSearchContents(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkCreateContent: (contents, options) => {
            const methodLogData = {
                method_name: 'bulkCreateContent',
                service_name: 'wix.multilingual.translation.content.v1.TranslationContent',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-multilingual.v2,entity=wix.multilingual.translation.v1.content,environment=velo-frontend,method-fqn=wix.multilingual.translation.content.v1.TranslationContent.bulkCreateContent',
            };
            return universalBulkCreateContent(contents, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkUpdateContent: (contents, options) => {
            const methodLogData = {
                method_name: 'bulkUpdateContent',
                service_name: 'wix.multilingual.translation.content.v1.TranslationContent',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-multilingual.v2,entity=wix.multilingual.translation.v1.content,environment=velo-frontend,method-fqn=wix.multilingual.translation.content.v1.TranslationContent.bulkUpdateContent',
            };
            return universalBulkUpdateContent(contents, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkUpdateContentByKey: (contents, options) => {
            const methodLogData = {
                method_name: 'bulkUpdateContentByKey',
                service_name: 'wix.multilingual.translation.content.v1.TranslationContent',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-multilingual.v2,entity=wix.multilingual.translation.v1.content,environment=velo-frontend,method-fqn=wix.multilingual.translation.content.v1.TranslationContent.bulkUpdateContentByKey',
            };
            return universalBulkUpdateContentByKey(contents, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkDeleteContent: (contentIds) => {
            const methodLogData = {
                method_name: 'bulkDeleteContent',
                service_name: 'wix.multilingual.translation.content.v1.TranslationContent',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-multilingual.v2,entity=wix.multilingual.translation.v1.content,environment=velo-frontend,method-fqn=wix.multilingual.translation.content.v1.TranslationContent.bulkDeleteContent',
            };
            return universalBulkDeleteContent(contentIds, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        removeContentsByFilter: (options) => {
            const methodLogData = {
                method_name: 'removeContentsByFilter',
                service_name: 'wix.multilingual.translation.content.v1.TranslationContent',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-multilingual.v2,entity=wix.multilingual.translation.v1.content,environment=velo-frontend,method-fqn=wix.multilingual.translation.content.v1.TranslationContent.removeContentsByFilter',
            };
            return universalRemoveContentsByFilter(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        republishContentByFilter: (options) => {
            const methodLogData = {
                method_name: 'republishContentByFilter',
                service_name: 'wix.multilingual.translation.content.v1.TranslationContent',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-multilingual.v2,entity=wix.multilingual.translation.v1.content,environment=velo-frontend,method-fqn=wix.multilingual.translation.content.v1.TranslationContent.republishContentByFilter',
            };
            return universalRepublishContentByFilter(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        NodeType,
        WidthType,
        PluginContainerDataAlignment,
        Type,
        Target,
        TextAlignment,
        LineStyle,
        Width,
        Alignment,
        ViewMode,
        LayoutType,
        Orientation,
        Crop,
        ThumbnailsAlignment,
        Source,
        MapType,
        ViewRole,
        VoteRole,
        PollLayoutType,
        PollLayoutDirection,
        BackgroundType,
        DecorationType,
        FontType,
        AppType,
        InitialExpandedItems,
        Direction,
        VerticalAlignment,
        NullValue,
        UpdaterIdentity,
        PublishStatus,
        SortOrder,
        SortType,
        SortDirection,
        MissingValues,
        ScalarType,
        NestedAggregationType,
        Interval,
        AggregationType,
        Mode,
        State,
        SiteCreatedContext,
        Namespace,
        DeleteStatus,
        WebhookIdentityType,
    };
}
//# sourceMappingURL=multilingual-translation-v1-content.frontend.js.map